import classNames from 'classnames'
import ReactSlider from 'react-slider'

import type { ReactElement } from 'react'
import type { ReactSliderProps } from 'react-slider'

import Button from '~/components/Buttons/Button'

import './styles.scss'

interface Props extends ReactSliderProps {
  steps?: number
}

const Slider = ({ steps = 10, ...props }: Props): ReactElement => {
  const classes = classNames('slider-component', props.className)

  const handleButtonClick = (value: number) => {
    props.onChange && props.onChange(value, value)
  }

  return (
    <div className="slider-container">
      <ReactSlider
        {...props}
        className={classes}
        thumbClassName="slider-component__thumb"
        trackClassName="slider-component__track"
      />
      <div className="slider-controls">
        {[...new Array(steps + 1)].map((_, index) => (
          <Button ghost key={index} onClick={() => handleButtonClick(index * steps)} size="small" type="button">
            {index * steps}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default Slider
